import { Grid, GridItem, Text } from "@chakra-ui/react";
import React from "react";

export interface SummaryRow {
  label: string;
  value: React.ReactNode;
}

// 요약 모달의 라벨-값 표. 값이 비어 있으면 "-" 로 보여준다.
export default function SummaryRows({ rows }: { rows: SummaryRow[] }) {
  return (
    <Grid
      gridTemplateColumns={"140px minmax(0, 1fr)"}
      rowGap={"8px"}
      columnGap={"12px"}
      alignItems={"center"}
      fontSize={"12px"}
    >
      {rows.map((row) => (
        <React.Fragment key={row.label}>
          <GridItem>
            <Text fontWeight={"700"} color={"#6F6F6C"}>
              {row.label}
            </Text>
          </GridItem>
          <GridItem minWidth={0}>
            {row.value === undefined || row.value === null || row.value === "" ? (
              <Text>-</Text>
            ) : typeof row.value === "string" || typeof row.value === "number" ? (
              <Text wordBreak={"break-all"}>{row.value}</Text>
            ) : (
              row.value
            )}
          </GridItem>
        </React.Fragment>
      ))}
    </Grid>
  );
}
